import api from "./axiosConfig";
import { TESTIMONIAL_ENDPOINT } from "./apiEndpoints";
import { getItem } from "../utils/localStorageUtil";
import { logError } from './errorLogService';
const isZho = getItem("lang") == "zho";

const mockTestimonialDataZho = [
  {
    id: 172,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Alexandre_Doblinski.webp",
    author: "Alexandre Doblinski",
    role: "巴西 Semear Comercial Agrícola 公司的联合创始人",
    quote:
      "Rainbow是一家秉持创新理念的公司，凭借着领先的尖端技术，让我们有十足底气为客户呈上最优质、最具创新性的解决方案。展望未来，我们志在进一步拓展并巩固与Rainbow的合作伙伴关系，充分挖掘其丰富多元的产品组合优势，借助Rainbow在持续发展且充满活力的巴西市场所树立的良好信誉与强大影响力，推动双方事业迈向新高度。 ",
  },
  {
    id: 173,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Sim_Teong_Ping.webp",
    author: "Sim Teong Ping, William",
    role: "马来西亚",
    quote:
      "Rainbow产品质量过硬，值得信赖，这让我们能够充满底气地为农民解决耕作时面临的抗药性难题。Rainbow拥有完整的产品体系，可据此制定并执行行之有效的抗性管理方案。与众多跨国公司相比，Rainbow的优势十分突出，其产品不仅品质有保障，价格也相当实惠。这一特性极大地减轻了农民的成本压力，同时能确保农业生产收获令人满意的成果 。 ",
  },
  {
    id: 174,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Fredy_Illescas.webp",
    author: "Fredy Illescas",
    role: "Integral Distributors - 危地马拉 INTEAGRO",

    quote:
      "对于 Rainbow 和 Integro 而言，双方的合作堪称一段成果丰硕的历程。Rainbow 凭借其先进的技术专长，与 Integro 深厚的市场底蕴相得益彰，二者优势互补，构建起高效的协同模式，为合作奠定了坚实基础。在此基础上，双方携手打造出强大的产品组合，提供优质服务，树立起卓越的品牌信誉，这些要素共同构成了合作成功的核心驱动力，推动品牌在所运营的区域内持续拓展，实现稳健增长。",
  },
  {
    id: 175,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Krittamat_Weerabut.webp",
    author: "Krittamat Weerabut",
    role: "Tonaor Agriculture Co., Ltd., 泰国",

    quote:
      "与Rainbow合作，我深感自信与安心。我对其产品质量深信不疑，也极为看重他们团队所提供的优质售后服务。Rainbow的产品极具价值，在成本把控与质量保障之间达到了理想平衡。不仅如此，公司还推出各类创新解决方案，力求全方位、高效地应对农业领域的诸多挑战 。 ",
  },
  {
    id: 176,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Sedat_Dundar.webp",
    author: "Sedat Dündar",
    role: "Sedat Dündar - Doga Agriculture, 土耳其",
    quote:
      "Rainbow在土耳其运营已有一年，我们深感荣幸能从其起步阶段便携手合作。在这段时间里，我们对Rainbow的生物产品进行了细致观察，其卓越品质展露无遗，深受本地农民青睐。Rainbow有着独特的经营模式，集产品生产与销售于一体，通过这种方式有效提升了产品附加值。他们对自家产品始终如一地坚定支持，这份自信极大地增强了我们对其的信任。 ",
  },
  {
    id: 177,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Luciano_Sapelli.webp",
    author: "Luciano Sapelli",
    role: "PGG Wrightson Seeds (DLF Seeds Uruguay S.A.), 乌拉圭",

    quote:
      "自2016年起，我们便与Rainbow建立合作关系，作为其在乌拉圭的业务伙伴，至今已有超8年的合作历程。我们与Rainbow的携手之路一直顺畅愉悦。在此，我们尤其要称赞其乌拉圭团队的杰出工作表现，以及他们积极倾听我方需求的诚意。Rainbow能够提供全面的登记服务，旗下产品在配方设计与呈现形式上均展现出卓越品质，无疑是我们最为信赖的合作伙伴。 ",
  },
  {
    id: 178,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Jose_Miguel_Rios_Mendez.webp",
    author: "Jose Miguel Ríos Mendez",
    role: "PetroAgro, 墨西哥",

    quote:
      "Petroagro与Rainbow的合作历程十分愉快。相较竞争对手，Rainbow的显著优势在于拥有极为广泛且多样的产品组合。其丰富的产品种类，能够为各类农业需求提供全面、完善的作物保护解决方案。凭借不断推出创新且可靠的产品选择，Rainbow在市场中始终出类拔萃，进一步稳固了其作为值得信赖合作伙伴的地位 。 ",
  },
  {
    id: 179,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Henry_Baldera_Vidaurre.webp",
    author: "Henry Baldera Vidaurre",
    role: "Inversiones Agrobaldera Sac, 秘鲁",

    quote:
      "与Rainbow合作，堪称一段极为积极的历程。这首先得益于他们以极具竞争力的价格，提供品质上乘的产品。而真正让Rainbow在众多合作伙伴中脱颖而出的，则是其全方位的卓越支持。他们不仅能给出极具价值的专业建议，尊重指定区域的实际情况与特殊需求，还能在营销层面给予大力协助。从精心制作的宣传材料，到带有品牌标识的标牌，再到各类品牌帽子等周边产品，无一不彰显着他们对合作的用心，以及对实现合作共赢目标的坚定承诺 。 ",
  },
  {
    id: 180,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Jose_Motz.webp",
    author: "José Motz",
    role: "Agropecuaria Montelibano, 洪都拉斯",

    quote:
      "在生产的每一个阶段，Rainbow始终是我们最为坚实可靠的合作伙伴，一路助力我们斩获优异成绩。在研究领域，Rainbow给予的支持成效显著，促使我们成功制定出保障可持续发展的战略方案。作为我们的核心合作伙伴，Rainbow与我们携手共进，我们也满怀期待，渴望与他们一同挖掘未来潜藏的无限机遇。Rainbow脱颖而出的关键在于其快速响应的能力，这一优势产生了深远影响，极大地推动了合作项目的发展。这样稳固且高效的伙伴关系，为持续进步奠定了坚实基础，我们也满心期许，在未来能续写更多成功篇章 。 ",
  },
  {
    id: 181,
    image_src: "https://d7n4bh3bohn60.cloudfront.net/assets/1/site_content/testimonial/Andres_Confesor_Santana.webp",
    author: "Andrés Confesor Santana",
    role: "Agrevo Dominicana S.R.L., 多米尼加共和国",
    quote:
      "与Rainbow合作，堪称一段令人极为满意的经历。生产商对Rainbow产品的质量以及呈现形式给予了极高赞誉。Rainbow凭借快速响应客户需求、拥有多样化产品配方、独特新颖的产品展示方式、优质贴心的服务，以及具备市场竞争力的价格，在众多同行中崭露头角。这些优势要素相辅相成，稳固地奠定了Rainbow作为可靠合作伙伴的地位，助力其为客户持续提供高效且创新的农业解决方案 。 ",
  },
];

const mockTestimonialData = [
  {
    quote: `Rainbow is an innovation-driven company with cutting-edge technology, enabling us to confidently deliver the best quality and innovative solutions to our customers. Looking ahead, we aim to further expand and strengthen our partnership, fully leveraging Rainbow's broad and diverse portfolio, alongside the credibility and strong presence it continues to establish in the ever-growing and dynamic Brazilian market.`,
    author: "Alexandre Doblinski",
    role: "Co-founder at Semear Comercial Agrícola, Brazil",
    image_src: "/assets/images/testimonials/Alexandre_Doblinski.webp",
    order: 1,
  },
  {
    quote: `The trusted product quality encourages us to provide solutions to farmers confidently, to solve their P&D of farming. The complete product portfolio of Rainbow enables an effective resistance management strategy. Rainbow provides prodcuts of trusted quality as of other multinational companies, as a convenient price, which helps to reduce the cost burden of farmerswhile achievieng satisfactory results.`,
    author: "Sim Teong Ping, William",
    role: "Aik Hwa, Malaysia",
    image_src: "/assets/images/testimonials/Sim_Teong_Ping.webp",
    order: 2,
  },
  {
    quote: `For both Rainbow and Integro, the partnership has been a positive experience. The robust portfolio, excellent service, and strong credibility that Rainbow has built with Inteagro-and vice versa-have been key factors in this success. Rainbow's technological expertise has been complemented by Inteagro's deep market knowledge, creating a synergy that has been highly effective and allowed the brand to grow in the regions they manage.`,
    author: "Fredy Illescas",
    role: "Distribuidores Integrales - INTEAGRO, Guatemala",
    image_src: "/assets/images/testimonials/Fredy_Illescas.webp",
    order: 3,
  },
  {
    quote: `I feel confident and comfortable doing business with Rainbow. I trust the quality of their products and value the excellent after-sales service provided by their team. Rainbow's offerings deliver exceptional value, striking the ideal balance between cost and quality. Additionally, the company provides a wide range of innovative solutions designed to effectively address diverse agricultural challenges in a comprehensive manner.`,
    author: "Krittamat Weerabut",
    role: "Tonaor Agriculture Co., Ltd., Thailand",
    image_src: "/assets/images/testimonials/Krittamat_Weerabut.webp",
    order: 4,
  },
  {
    quote: `Rainbow has been operating in Turkey for one year, and we are proud to have partnered with them from the beginning. During this time, we closely observed Rainbow's biological products, which are of exceptional quality and valued by our farmers. What sets Rainbow apart is producing and selling their own products, adding value. The unwavering support and confidence in standing behind their products strengthen our trust.`,
    author: "Sedat Dündar",
    role: "Sedat Dündar - Doga Agriculture, Turkey",
    image_src: "/assets/images/testimonials/Sedat_Dundar.webp",
    order: 5,
  },
  {
    quote: `We have been working with Rainbow since 2016 and as business partners in Uruguay for over 8 years. Our experience with Rainbow has been excellent. We especially commend the outstanding work of the Uruguay team and their willingness to listen to our needs. Rainbow offers a wide range of registrations along with exceptional quality in the formulation and presentation of their products, making them a reliable partner.`,
    author: "Luciano Sapelli",
    role: "PGG Wrightson Seeds (DLF Seeds Uruguay S.A.), Uruguay",
    image_src: "/assets/images/testimonials/Luciano_Sapelli.webp",
    order: 6,
  },
  {
    quote: `Petroagro's experience working with Rainbow has been highly positive. Rainbow’s key advantage over competitors lies in its extensive and diverse product portfolio. This wide variety allows for comprehensive and well-rounded crop protection solutions, tailored to meet different agricultural needs. By offering innovative and reliable options, Rainbow consistently stands out in the market, solidifying its position as a trusted partner.`,
    author: "Jose Miguel Ríos Mendez",
    role: "PetroAgro, México",
    image_src: "/assets/images/testimonials/Jose_Miguel_Rios_Mendez.webp",
    order: 7,
  },
  {
    quote: `Working with Rainbow has been a highly positive experience, thanks to their high-quality products offered at competitive prices. What truly sets Rainbow apart is their exceptional support, which includes valuable advice, respect for assigned areas, and strong marketing assistance. This support is evident in their promotional materials, signage, and branded items like hats, demonstrating their commitment to partnering for mutual success.`,
    author: "Henry Baldera Vidaurre",
    role: "Inversiones Agrobaldera Sac, Perú",
    image_src: "/assets/images/testimonials/Henry_Baldera_Vidaurre.webp",
    order: 8,
  },
  {
    quote: `Rainbow has been a reliable partner across all stages of production, helping us achieve excellent results. Their support in research has enabled strategic solutions that ensure sustainability. Rainbow is a key partner, and we are eager to explore future opportunities together. Their prompt responsiveness sets them apart, making an impact. This partnership fosters growth, and we look forward to continued success.`,
    author: "José Motz",
    role: "Agropecuaria Montelibano, Honduras",
    image_src: "/assets/images/testimonials/Jose_Motz.webp",
    order: 9,
  },
  {
    quote: `Working with Rainbow has been a highly satisfying experience. Producers have shown strong acceptance of their product quality and presentation. Rainbow stands out for providing quick responses, diverse formulations, unique presentations, excellent service, and competitive prices. This combination of factors solidifies Rainbow’s position as a reliable partner in delivering effective and innovative agricultural solutions.`,
    author: "Andrés Confesor Santana",
    role: "Agrevo Dominicana S.R.L., República Dominicana",
    image_src: "/assets/images/testimonials/Andres_Confesor_Santana.webp",
    order: 10,
  },
];

export const fetchTestimonial = async (retryCount = 2) => {
  try {
    const response = await api.get(TESTIMONIAL_ENDPOINT(), {
      timeout: 30000, // 30 seconds timeout
    });
    return response.data;
  } catch (error) {
    const isTimeout = error.code === 'ECONNABORTED' || error.message?.includes('timeout');
    const isNetworkError = !error.response && error.request;
    
    // Retry logic for timeouts and network errors
    if ((isTimeout || isNetworkError) && retryCount > 0) {
      console.warn(`Testimonial data fetch ${isTimeout ? 'timeout' : 'network error'}, retrying... (${retryCount} attempts left)`);
      await new Promise(resolve => setTimeout(resolve, 1000)); // Wait 1 second before retry
      return fetchTestimonial(retryCount - 1);
    }

    console.error("Error fetching hero data", error);

    await logError('testimonial_data_fetch', error, {
      endpoint: TESTIMONIAL_ENDPOINT(),
      response_status: error.response?.status,
      response_data: error.response?.data,
    });

    return isZho ? mockTestimonialDataZho : mockTestimonialData;
  }
};
